export const DATA_ACCESS = process.env.https://ssl-prd-uz0-sds.worldline-solutions.com/data_access
export const CHIAVI_ORACOLO = process.env.https://ssl-prd-uz0-sds.worldline-solutions.com/chiavi_oracolo
export const DIP_GCP = process.env.gw-dip.worldline-solutions.com
